<template>
  <div id="item" v-if="item.id">
    <nav class="sub-page-nav has-text-centered">
      <back-arrow></back-arrow>
      <p class="is-cs-6 has-text-centered">{{ item.name }}</p>
    </nav>
    <div class="wrapper">
      <div class="item" :class="{'sold-out': item.sold_out, r18: item.r18}">
        <div class="item-image">
          <div class="main-image">
            <figure class="image" v-for="(image, i) in item.images" :key="i">
              <cachalog-img :type="'background'" :caption="image.caption" :full-path="image.full_path" :source="image.source"></cachalog-img>
            </figure>
          </div>
          <!--<div class="slide-nav has-text-centered">●●●●</div>-->
          <!--<div class="page-edit-button" v-if="$store.getters.isMember">
            <router-link :to="{name: 'item-editor'}">
              <span class="icon">
                <i class="fas fa-lg fa-edit"></i>
              </span>
            </router-link>
          </div>-->
        </div>
        <div class="detail">
          <h1 class="title is-cs-2 item-name">{{ item.name }}</h1>
          <div class="description">
            <p class="is-cs-4">{{ item.description }}</p>
          </div>
          <div class="level is-mobile">
            <div class="is-cs-5 level-left">
              <span class="is-cs-2">{{ item.price.value.toLocaleString() }}</span> 円（{{ item.price.tax ? '税込' : '税抜' }}）
            </div>
            <cachalog-item-quantity :index="index" parent="page" :wishlist="wishlist"></cachalog-item-quantity>
          </div>
        </div>
      </div>
      <div class="page-info level is-mobile">
        <figure class="image is-48x48" v-for="(image, i) in [page.images[1]]" :key="i">
          <cachalog-img class="is-rounded" :type="'background'" :caption="image.caption" :full-path="image.full_path" :source="image.source"></cachalog-img>
        </figure>
        <h2 class="is-cs-5 is-c-text">{{ page.title }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mixin, indexOf } from './common.js'
import backArrow from './design/back-arrow.vue'
export default {
  components: {
    'back-arrow': backArrow
  },
  mixins: [mixin],
  props: ['pageId', 'itemId'],
  computed: {
    ...Vuex.mapState({
      user: 'user',
      page: 'page',
      wishlist: 'wishlist'
    }),
    itemName () {
      return this.item.name || ''
    },
    pageTitle () {
      return this.page.title || ''
    },
    wishItem () {
      return this.wishlist.items[this.index] || {}
    },
    item () {
      if (this.page.id === this.pageId) {
        return this.page.items[this.index] || this.$store.commit('notFound', true)
      } else {
        return this.page.items[this.index] || {name: '', price: {}}
      }
    },
    index () {
      return indexOf(this.page.items, 'id', this.itemId)
    }
  },
  created () {
    if (this.page.id !== this.pageId) {
      this.$store.dispatch('fetchPage', this.pageId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/item.vue